<template>
  <!-- Faded stand-ins for the ranked ads, creative velocity and creator partnership previews, for brands with no ad data yet -->
  <div class="w-full flex flex-col gap-3 pointer-events-none select-none">
    <!-- Top Ranked Ads -->
    <div class="skeleton-panel w-full flex flex-col gap-1 p-1 bg-white border border-border-normal overflow-hidden">
      <div class="flex items-center gap-2 p-2 opacity-40">
        <div class="flex items-center gap-1 p-1">
          <AdRankIcon class="text-icon-normal flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
            Top Ranked Ads
          </BaseText>
        </div>
        <div class="flex items-center gap-1 p-1">
          <EvergreenIcon class="text-text-subdued flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-subdued whitespace-nowrap">
            Evergreen Winners
          </BaseText>
        </div>
        <div class="flex items-center gap-1 p-1">
          <BreakoutIcon class="text-text-subdued flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-subdued whitespace-nowrap">
            Breakouts
          </BaseText>
        </div>
      </div>
      <div class="ad-cards-row w-full flex gap-1 p-1 bg-neutral-25 opacity-40 overflow-hidden">
        <div v-for="i in 6" :key="`ad-card-skeleton-${i}`" class="ad-card flex-shrink-0 bg-white" />
      </div>
    </div>
    <!-- Creative Velocity -->
    <div class="skeleton-panel w-full flex flex-col gap-1 p-1 bg-white border border-border-normal overflow-hidden">
      <div class="flex items-center p-2 opacity-40">
        <div class="flex items-center gap-1 p-1">
          <CreativeVelocityIcon class="text-icon-normal flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
            Meta Creative Velocity
          </BaseText>
        </div>
      </div>
      <div class="w-full flex gap-2 px-1 pb-1 opacity-40">
        <div v-for="i in 4" :key="`velocity-count-skeleton-${i}`" class="velocity-count flex-1 min-w-0 bg-neutral-25" />
      </div>
      <div class="velocity-graph w-full" />
    </div>
    <!-- Creator Partnerships -->
    <div class="skeleton-panel w-full flex flex-col gap-1 p-1 bg-white border border-border-normal overflow-hidden">
      <div class="flex items-center p-2 opacity-40">
        <div class="flex items-center gap-1 p-1">
          <CreatorPartnershipIcon class="text-icon-normal flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
            Creator Partnerships
          </BaseText>
        </div>
      </div>
      <!-- Partnership split and creator list -->
      <div class="partnerships-row w-full grid gap-1 p-1 bg-neutral-25 opacity-40">
        <div class="partnerships-card bg-white" />
        <div class="partnerships-card bg-white" />
      </div>
    </div>
  </div>
</template>

<script>
import AdRankIcon from '../../globals/Icons/SpyderModeIcons/AdRankIcon.vue'
import BreakoutIcon from '../../globals/Icons/SpyderV2Icons/BreakoutIcon.vue'
import CreativeVelocityIcon from '../../globals/Icons/SpyderV2Icons/CreativeVelocityIcon.vue'
import CreatorPartnershipIcon from '../../globals/Icons/SpyderV2Icons/CreatorPartnershipIcon.vue'
import EvergreenIcon from '../../globals/Icons/SpyderV2Icons/EvergreenIcon.vue'

export default {
  name: 'TrackBrandPreviewsSkeleton',
  components: {
    AdRankIcon,
    BreakoutIcon,
    CreativeVelocityIcon,
    CreatorPartnershipIcon,
    EvergreenIcon
  }
}
</script>

<style scoped>
.skeleton-panel {
  border-radius: 20px;
}
.ad-cards-row {
  border-radius: 16px;
}
.ad-card, .partnerships-card {
  border-radius: 12px;
  box-shadow: 0px 6px 12px -3px rgba(26, 35, 66, 0.04), 0px 2px 4px -1.5px rgba(26, 35, 66, 0.04), 0px 1px 2px -0.75px rgba(26, 35, 66, 0.04);
}
.ad-card {
  width: 228px;
  height: 316px;
}
/* Same layout as CreatorPartnershipsPreview's content */
.partnerships-row {
  grid-template-columns: 224px 1fr;
  height: 244px;
  border-radius: 16px;
}
.velocity-count {
  height: 68px;
  border-radius: 10px;
}
.velocity-graph {
  height: 348px;
}
</style>
